(function ($) {
    const tooltipSelector = '[title]:not(option)';
    const onTooltipClicked = function () {
        $(this).tooltip('hide');
    };

    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */

    $.fn.enableTooltips = function (options) {
        $(tooltipSelector, this).tooltip(options).click(onTooltipClicked);

        $('select', this).each(function () {
            $('.select2-selection__clear', $(this).parent()).tooltip('dispose'); // remove tooltips from clear buttons
        }).change(function () {
            const $selectParent = $(this).parent();
            $(tooltipSelector, $selectParent).tooltip('dispose').tooltip().click(onTooltipClicked);
            $('.select2-selection__clear', $selectParent).tooltip('dispose'); // remove tooltips from clear buttons
        });

        return this;
    };
}(jQuery));